import React, { PureComponent, Fragment } from 'react';
import { custData } from "./data";
import Tier1 from "./Tier1";
import Tier2 from "./Tier2";
import Tier3 from "./Tier3";
import Header from "./Header";
import './App.css';



class App extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      tier1: -1,
      tier2: -1,
    };
  }

  resetTiers = () => {
    this.setState(Object.assign({}, this.state, {
      tier1: -1,
      tier2: -1,
    }));
  }

  setTier1 = (idx) => {
    this.setState(Object.assign({}, this.state, {
      tier1: idx,
    }));
  }

  setTier2 = (idx) => {
    this.setState(Object.assign({}, this.state, {
      tier2: idx,
    }));
  }

  render() {
    const {
      tier1,
      tier2,
    } = this.state;

    return (
      <div className='howtobuy'>
        {tier1 < 0 && tier2 < 0 &&
          <Tier1 data={custData} selectItem={this.setTier1} />
        }
        {tier1 >= 0 && tier2 < 0 &&
          <Fragment>
            {custData[tier1].optionsTier3 &&
              <Fragment>
                <Header tier1={custData[tier1].name} tier2={'NA'} clearItems={this.resetTiers} />
                <Tier3 data={custData[tier1].optionsTier3} disclaimer={custData[tier1].disclaimer} />
              </Fragment>
            }
            {custData[tier1].optionsTier2 &&
              <Fragment>
                <Header tier1={custData[tier1].name} tier2={''} clearItems={this.resetTiers} />
                <Tier2 data={custData[tier1].optionsTier2} selectItem={this.setTier2} />
              </Fragment>
            }
          </Fragment>
        }
        {tier2 >= 0 &&
          <Fragment>
            <Header tier1={custData[tier1].name} tier2={custData[tier1].optionsTier2[tier2].name} clearItems={this.resetTiers} />
            <Tier3 data={custData[tier1].optionsTier2[tier2].optionsTier3} disclaimer={custData[tier1].disclaimer} />
          </Fragment>
        }
      </div>
    )
  }

}

export default (App);
